import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import StylePropType from 'react-style-proptype';

// import ProfilePropType from '../../proptypes/profile';
import Styles from './TopBar.styles.js';
import UserCard from '../../components/UserCard/';
import HamburgerButton from '../HamburgerButton';

const TopBar = props => (
  <div style={[Styles.wrapper, props.wrapperStyle]}>
    <HamburgerButton onClick={props.onHamburgerClick} />
    {props.children && <div style={[Styles.children, props.innerStyle]}>{props.children}</div>}
    <UserCard onClick={props.onUserClick} profile={props.profile} />
  </div>
);

TopBar.propTypes = {
  children: PropTypes.node,
  // profile: ProfilePropType,
  onUserClick: PropTypes.func,
  onHamburgerClick: PropTypes.func,
  wrapperStyle: StylePropType,
};

TopBar.defaultProps = {
  children: null,
  profile: null,
  wrapperStyle: {},
  onUserClick: () => {},
  onHamburgerClick: () => {},
};

export default Radium(TopBar);



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.js